import type {ProductId} from '../domain/product';

export const keys = {
  list: () => ['user-products', 'list'] as const,
  byId: (productId: ProductId) => ['user-products', 'byId', {productId}] as const,
  catalogCandidatesAll: () => ['user-products', 'catalog-candidates'] as const,
  catalogCandidates: (q: string, brand: string | null) =>
    [...keys.catalogCandidatesAll(), 'search', q, brand] as const,
  mutations: {
    resolve: () => ['user-products', 'mutations', 'resolve'] as const,
    createFromCatalog: () => ['user-products', 'mutations', 'createFromCatalog'] as const,
    createManual: () => ['user-products', 'mutations', 'createManual'] as const,
    update: () => ['user-products', 'mutations', 'update'] as const,
    delete: () => ['user-products', 'mutations', 'delete'] as const,
  },
} as const;
